import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import useIsMobile from '../../../hooks/useIsMobile';
import FullVersion from './FullVersion';
import CompactVersion from './CompactVersion';

const NationalTaxServiceCredentialsOverlay = ({ source }) => {
  const isMobile = useIsMobile('desktop');
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        setContainerHeight(containerRef.current.offsetHeight);
      }
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <Box
      sx={{
        height: '100%',
      }}
      ref={containerRef}
    >
      <Box sx={{
        my: 'auto',
        height: '100%',
      }}
      >
        {(containerHeight < 300 && !isMobile)
          ? <CompactVersion source={source} /> : <FullVersion source={source} />}
      </Box>
    </Box>
  );
};

NationalTaxServiceCredentialsOverlay.propTypes = {
  source: PropTypes.string,
};

NationalTaxServiceCredentialsOverlay.defaultProps = {
  source: null,
};

export default NationalTaxServiceCredentialsOverlay;
